import React, {  } from 'react';
import { withStyles, StyledComponentProps } from '@material-ui/core';
import { withRouter } from 'react-router';
import { actionCreator as chatActions, IActions as IChatActions } from '../scenes/chat/store/actions/creators';
import { IApplicationState } from '../store/ApplicationState';
import { connect } from 'react-redux';
import { layoutStyle } from './Layout.style';
import { IMediaQueryProps } from './withMediaQuery';
import { SignalRConnection } from '../common/SignalR/SignalRConnection';
import { IRouterAppProps } from '../common/interfaces/IRouterAppProps';
import { IChatMessage } from '../model/chatmessage';

interface IOuterProps {
    currentMenuSection: string;
}
interface IProps extends StyledComponentProps, IRouterAppProps, IChatActions, IMediaQueryProps {
    newMessageReceived: boolean;
}

class HandlerMessageReceivedClass extends React.Component<IProps & IOuterProps> {


    componentDidMount = () => {
        console.warn("registered SendMessageToAdmin")
        setTimeout(() => SignalRConnection.registerConnectionHandler('SendMessageToAdmin', this.UpdateStoreMessages), 1000);
    }

    private UpdateStoreMessages = (message: IChatMessage, sub: string) => {
        if (this.props.currentMenuSection === "Chat") {
            this.props.receiveMessageWebSocket(message, this.getCurrentUserSub());
            this.props.setChatMessagesAsSeen(this.getCurrentUserSub());
        }
        else {
            this.props.setNewMessageReceivedStatus();
        }

    }


    getCurrentUserSub = () => {
        let pathSplited = this.props.history.location.pathname.split("/");
        //Il sub selezionato è l'ultimo valore del pathname
        let sub = pathSplited[pathSplited.length - 1];
        return sub;
    };

    componentWillUnmount() {
        console.warn("unregistered SendMessageToAdmin")
        SignalRConnection.removeConnectionHandler('SendMessageToAdmin');
    }

    render() {
        return (null)
    }

}

const mapStateToProps = (state: IApplicationState, ownp: any) => ({ ...ownp, newMessageReceived: state.chatmessages.newMessageReceived });
const mapDispatchToProps = d => ({ ...chatActions(d) });

export const HandlerMessageReceived = withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(layoutStyle)(HandlerMessageReceivedClass)));